import { ChangeEvent, useCallback, useMemo, useState } from "react";
import { getItemPopupList } from "src/apis/itemApi";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { ItemDto } from "src/dtos/item/itemDto";
import useUiuxStore from "src/store/useUiuxStore";
import { useCommonCodeStore } from '../../../../store/useCommonCodeStore';
import { defaultPRD3031_R01Filter, usePRD3031_R01Store } from "./Store_PRD3031_R01";
import { CompanyDto } from "src/dtos/company/companyDto";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { searchDateRangeFormString, searchLabelStyle } from "src/components/common/common";


interface Props {
    className?: string;
}

export const SearchSection_PRD3031_R01 = ({ 
}: Props) => {

	const {
		PRD3031_R01Filter, setPRD3031_R01Filter,
		showSubtotals, setShowSubtotals,
	 } = usePRD3031_R01Store();

	 const { 
		brandCdList,
		compCdList,
	} = useCommonCodeStore();

    // 달력 팝업 노출 여부 상태
    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
    
    const { setCodeSearchModalProps } = useUiuxStore();

	const itemCdHandleFoucsId = 'itemCd_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'itemCd',
			category: '품목',
			focusId: itemCdHandleFoucsId,
			responseMapping: {
				itemCd: 'itemCd',
				itemNm: 'itemNm',
			},
			searchFunction: async (searchText: string) => {
				const itemResponse = await getItemPopupList(searchText, '', '', '');
				return itemResponse.data.data.find(value => value.itemCd === searchText);
			},
			extraFilter: () => ({
				itemCd: PRD3031_R01Filter.itemCd || '',
				itemNm: PRD3031_R01Filter.itemNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: PRD3031_R01Filter,
		setEditData: setPRD3031_R01Filter,
		defaultData: defaultPRD3031_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'PRD3031_R01_search'
	});
	const subtotalCheckboxId = 'PRD3031_R01_showSubtotals';
	


    return (
        <div className="w-full ">
            <SearchSectionForm >
                <SearchDropDownForm<CompanyDto>
                    label="사업장"
                    value={PRD3031_R01Filter.compCd}
                    optionList={compCdList}
                    onChangeValue={v => setPRD3031_R01Filter({ compCd: v === 'all' ? '' : v })}
                    wrapperOption={{
                        wrapperStyle: "w-[200px] min-w-[200px] mr-[10px]",
                        titleStyle: "w-[45px] min-w-[45px] text-left",
                        selectStyle: "w-[100px] min-w-[100px]",
                    }}
                />
                <SearchDateRangeForm
                    label="생산일자"
                    visible={pickerVisible}
                    setVisible={setPickerVisible}
                    dateRange={PRD3031_R01Filter.productDateRange}
                    setDateRange={v => setPRD3031_R01Filter({ productDateRange: v })}
                    pickerPosition={pickerPosition}
                    setPickerPosition={setPickerPosition}
                    wrapperOption={{
                        wrapperStyle: "w-[250px] min-w-[250px] mr-[10px]",
                        titleStyle: searchLabelStyle,
                        dateRangeStyle: searchDateRangeFormString,
                    }}
                />
                <SearchDropDownForm<SysCodeDto>
                    label="브랜드"
                    value={PRD3031_R01Filter.brandCd}
                    optionList={brandCdList}
                    onChangeValue={v => setPRD3031_R01Filter({ brandCd: v === 'all' ? '' : v })}

                />
                <SearchCodeModalForm
                    label="품목코드"
                    value={PRD3031_R01Filter.itemCd}
                    valueLabel={PRD3031_R01Filter.itemNm}
					handleFoucsId={itemCdHandleFoucsId}
                    onChange={getFieldHandlers('itemCd').onChange}
                    onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
                    onKeyDown={getFieldHandlers('itemCd').onEnterKeyDown}
                />

                <label
                    htmlFor={subtotalCheckboxId}
                    className="text-s ml-16 cursor-pointer select-none"
                >
                    소계 표시
                </label>
                <input
                    id={subtotalCheckboxId}
                    type="checkbox"
                    checked={showSubtotals}
                    onChange={(event) => setShowSubtotals(event.target.checked)}
                    className="h-4 w-4 cursor-pointer accent-blue-600"
                />
            </SearchSectionForm>
        </div>
    );
};
